// API接口管理文件
import axios from 'axios';

// API基础地址
const API_BASE_URL = 'https://www.slfangshuijiao.com/api';
const DEPT_ID = 111;

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// 请求拦截器
apiClient.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    console.log('API请求:', config);
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    console.log('API响应:', response);
    return response;
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

// API接口定义
const API = {
  // 站点相关接口
  site: {
    // 获取栏目列表
    getColumnList: (params = {}) => {
      return apiClient.post('/site/columnList', {
        deptId: DEPT_ID,
        ...params
      });
    },
    
    // 获取栏目详情
    getColumnDetail: (columnId) => {
      return apiClient.post('/site/columnDetail', {
        columnId: columnId
      });
    },
    
    // 产品列表
    getProductList: (params = {}) => {
      return apiClient.post('/site/productList', {
        deptId: DEPT_ID,
        ...params
      });
    },
    
    // 产品详情
    getProductDetail: (productId, columnId = '') => {
      let url = `/site/productDetail?productId=${productId}`;
      if (columnId) {
        url += `&columnId=${columnId}`;
      }
      return apiClient.post(url);
    },
    
    // 产品购买
    productBuy: (data) => {
      return apiClient.post('/site/productBuy', {
        deptId: DEPT_ID,
        ...data
      });
    },
    
    // 验证码图片
    getCaptchaImage: (uuid) => {
      return `${API_BASE_URL}/site/captchaImage?uuid=${uuid}`;
    },
    
    // 在线联系信息
    getOnlineContact: (params = {}) => {
      return apiClient.post('/site/onlineContact', {
        deptId: DEPT_ID,
        ...params
      });
    },
    
    // 友情链接列表
    getOutsideList: (params = {}) => {
      return apiClient.post('/site/outsideList', {
        deptId: DEPT_ID,
        ...params
      });
    },
    
    // 全站搜索
    globalSearch: (param) => {
      return apiClient.post(`/site/globalSearch?deptId=${DEPT_ID}&param=${param}`);
    },
    
    // 轮播图列表
    getBannarList: (params = {}) => {
      return apiClient.post('/site/bannarList', {
        deptId: DEPT_ID,
        ...params
      });
    }
  },
  
  // 通用请求方法
  get: (url, params = {}) => {
    return apiClient.get(url, { params });
  },
  
  post: (url, data = {}) => {
    return apiClient.post(url, data);
  },
  
  put: (url, data = {}) => {
    return apiClient.put(url, data);
  },
  
  delete: (url) => {
    return apiClient.delete(url);
  }
};

export default API;
export { API_BASE_URL, DEPT_ID };